import {
  gradientCss,
  isGradient,
  type GradientPaint,
} from "../native/gradient";

export function inputGradient(input: HTMLInputElement): GradientPaint | null {
  try {
    const value: unknown = JSON.parse(input.dataset.gradient ?? "null");
    return isGradient(value) ? value : null;
  } catch {
    return null;
  }
}
export function syncPaintInput(input: HTMLInputElement, gradient: unknown) {
  input.dataset.gradient = JSON.stringify(
    isGradient(gradient) ? gradient : null,
  );
  input.dataset.gradientSupported = "true";
  input.classList.toggle("native-gradient-swatch", isGradient(gradient));
  input.style.setProperty(
    "--native-paint",
    isGradient(gradient) ? gradientCss(gradient) : input.value,
  );
}

export function textPaintPatch(
  input: HTMLInputElement,
  field: "color" | "stroke",
) {
  const channel = input.dataset.colorChannel;
  if (channel === "gradient")
    return { [field + "Gradient"]: inputGradient(input) };
  if (channel === "alpha")
    return { [field + "Alpha"]: Number(input.dataset.colorAlpha ?? 1) };
  return {
    [field]: input.value,
    ...(channel === "color" ? { [field + "Gradient"]: null } : {}),
    ...(channel !== "color" && input.dataset.colorAlpha !== undefined
      ? { [field + "Alpha"]: Number(input.dataset.colorAlpha) }
      : {}),
  };
}
